// extracted by mini-css-extract-plugin
export default {"textAreaInput":"_3s71O2Q9YFFJq0zyyE9vJn","error":"_3iUZEvh8-Fu8ZF4h0s_fU1"};